export const noFrontendApiError =
  "Clerk: You must add the frontendApi prop to your <ClerkProvider>";
export const noProviderError =
  "Clerk: You must wrap your application in a <ClerkProvider> component.";
export const noGuaranteeError =
  "Clerk: You're calling useClerk() before there's a guarantee the client has been loaded. Call useClerk() from a child of <SignedIn>, <SignedOut>, or <ClerkLoaded>, or use the withClerk() HOC.";
export const noGuaranteedUserError =
  "Clerk: You're calling useUser() before there's a guarantee there's an active user. Call useUser() from a child of <SignedIn> or use the withUser() HOC.";
